import { parseCookies } from 'nookies';

type Context = Parameters<typeof parseCookies>[0];

export const getCookies = (context?: Context) => {
  return parseCookies(context);
};

export const getCookieByKey = (key: string, context?: Context) => {
  return parseCookies(context)[key];
};
